import React, { Fragment } from 'react';
import Dropzone from "react-dropzone";
import createForm from "./Form";
import CheckBox from "../../form/CheckBox";
import ComponentField from "../../form/ComponentField";
import Figures from "../../form/Figures";
import { connect } from "src/store";
import EventForm from "./EventForm";
import ComponentConfig from "../../form/ComponentConfig";
import { set } from "../../../utils/dotutils";
import Button from "../../form/Button";
import Tabs from "../../layout/Tabs";
import TabContent from "../../layout/TabContent";
import Tab from "../../layout/Tab";
import Icon from "../../form/Icon";
import Confirm from "../../form/Confirm";
import DataGrid from "../../form/SelectorGrid/DataGrid";
import TextInput from "../../form/TextInput";
import Select from "../../form/Select";
import ColorPicker from "../../form/ColorPicker";
import FragmentEditor from "../FragmentEditor";
import NewLocationButton from "../NewLocationButton";
import TimeConfigEditor from "../TimeConfigEditor";
import TicketTypeEditor from "../TicketTypeEditor";
import ModalEditor from "../ModalEditor";
import isEqual from "lodash-es/isEqual";
import { ComponentListDataProviderProps } from "../../form/SelectorGrid/DataGrids/ListProviders/ComponentListDataProvider";
import { ListDataProviderProps } from "../../form/SelectorGrid/DataGrids/ListProviders/ListDataProvider";
import { isTrue } from "../../../utils/other";
import PodcastEpisodeEditor from "../PodcastEpisodeEditor";
import QuizEditor from "../QuizEditor";
import ProgramOptionEditor from "../ProgramOptionEditor";
import { SplitButton } from 'primereact/splitbutton';
import SelectorGrid from '../../form/SelectorGrid/SelectorGrid';
import { fileUpload } from '../../../utils/request';
import { remoteOptionFormatter } from '../../../utils/formatters';
import { loadComponent } from '../../../utils/components';
import SeoField from "../../form/SeoField";

type EventListType = (ListDataProviderProps | ComponentListDataProviderProps) & {
    program: object
}

type EventListPropsType = (ListDataProviderProps | ComponentListDataProviderProps) & EventListType;

const TimeConfigEditorList = (props) => <Fragment>
    <div className="form-group">
        <label className="control-label">Nyitvatartási időpontok</label>
        {props.children}
    </div>
</Fragment>;

class EventList extends React.Component<EventListPropsType, any> {
    render() {
        const events = this.props.data.items || [];
        if (this.props.program?.type?.preset?.single_event && events.length === 1) {
            const idx = 0;
            const event = events[idx];
            return <ComponentConfig key={idx} componentName="Event">
                <EventForm
                    inline={true}
                    values={{ ...event, program: this.props.program }}
                    getFieldProps={(field) => ({})}
                    setFieldValue={(field, value) => {
                        let data = { ...event };
                        set(data, field, value);
                        if (!isEqual(data, event)) {
                            return this.props.editItems([{ ...data }]);
                        }
                    }}
                />
            </ComponentConfig>
        }
        return (
            <Fragment>
                <Tabs
                    collapsable={true}
                    extraTabs={<Tab
                        tabName="plus"
                        className="pull-right"
                        onClick={() => {
                            this.props.addItems([{}]);
                        }}>
                        <Icon lib="fas" name="plus" /> Esemény
                    </Tab>}
                >
                    {events.map((event, idx) => {
                        let editor = null;
                        editor = <FragmentEditor
                            footer={idx > 0 && (
                                !!Object.values(event).find((value) => !!value)
                                    ?
                                    <Confirm
                                        color="danger"
                                        header="Törlés"
                                        body="Biztosan törlöd ezt a tételt?"
                                        acceptButton="Törlés"
                                        tooltip="Törlés"
                                        timeout={3}
                                        onAccept={(e) => {
                                            e && e.preventDefault();
                                            e && e.stopPropagation();
                                            this.props.removeItems([{ idx: event.idx, id: event.id }]);
                                        }}
                                    >Törlés</Confirm>
                                    :
                                    <Button
                                        color="danger"
                                        tooltip="Törlés"
                                        onClick={(e) => {
                                            e && e.preventDefault();
                                            e && e.stopPropagation();
                                            this.props.removeItems([{ idx: event.idx, id: event.id }]);
                                        }}
                                    >Törlés</Button>)
                            }
                        >
                            <ComponentConfig key={idx} componentName="Event">
                                <EventForm
                                    inline={true}
                                    values={{ ...event, program: this.props.program }}
                                    getFieldProps={(field) => ({})}
                                    setFieldValue={(field, value) => {
                                        let data = { ...event };
                                        set(data, field, value);
                                        if (!isEqual(data, event)) {
                                            return this.props.editItems([{ ...data }]);
                                        }
                                    }}
                                />
                            </ComponentConfig>
                        </FragmentEditor>
                        return <TabContent
                            key={idx}
                            tabLabel={<Fragment>
                                {" Esemény #" + String(event.id || (idx + 1)) + " " + (event.from && event.to ? "(" + (event.from || "") + " - " + (event.to || "") + ")" : (event.from ? "(" + event.from + ")" : (event.to ? "(" + event.to + ")" : ""))) + " "}
                            </Fragment>}
                            tabName={"event_" + idx}
                        >
                            {editor}
                        </TabContent>
                    })}
                </Tabs>
            </Fragment>
        );
    }
}

class ProgramForm extends React.Component<any, object> {

    state = {
        events: [],
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<object>, snapshot?: any) {
        if (prevProps.values[prevProps.componentConfig.idfield] !== this.props.values[this.props.componentConfig.idfield]) {
            this.setState({ events: [] });
        }
    }

    openDialog = () => {
        if (this.dropzoneRef) {
            this.dropzoneRef.open();
        }
    }

    onDrop = async (acceptedFiles) => {
        try {
            const response = await fileUpload({
                action: "Document.create",
                uploaded_file: acceptedFiles[0],
                data: {
                    field: 'documents',
                    component: this.props.componentConfig.componentname,
                    component_id: this.props.values[this.props.componentConfig.idfield],
                    type: 4 // userDocument
                }
            });
            if (this.props.saveChanges) {
                this.props.saveChanges(this.props.name, response.data);
            }
            this.documents.refresh();
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const events = this.props.values.events || (this.props.values[this.props.componentConfig.idfield] ? [] : [{ idx: 0 }]);
        if (!this.props.values?.type) {
            return <Fragment>
                <form onSubmit={this.props.handleSubmit}>
                    <div className="row form-row">
                        <div className="col-md-2">
                            <Select
                                component="ProgramType"
                                storeType="local"
                                label="Típus"
                                name="type"
                                view={["preset"]}
                                isClearable={false}
                                objectValue={true}
                                value={this.props.values.type}
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("type")}
                            />
                        </div>
                    </div>
                </form>
            </Fragment>;
        }
        return (
            <Fragment>
                <form onSubmit={this.props.handleSubmit}>
                    <div className="row form-row">
                        <div className="col-md-2">
                            <Select
                                component="ProgramType"
                                storeType="local"
                                label="Típus"
                                name="type"
                                view={["preset"]}
                                isClearable={false}
                                objectValue={true}
                                value={this.props.values.type}
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("type")}
                            />
                        </div>
                        <div className="col-sm-4">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="name"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Név"
                            />
                        </div>
                        <div className="col-sm-2">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="organizer"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Szervező"
                                labelKey="name"
                            />
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <ColorPicker
                                    name="color"
                                    value={this.props.values.color}
                                    isClearable={true}
                                    label="Szín"
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("color")}
                                />
                            </div>
                        </div>
                        <div className="col-sm-2">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name={this.props.componentConfig.idfield}
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Kód"
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-3">
                            <Select
                                component="PointOfSale"
                                storeType="local"
                                label="Eladási hely"
                                name="pos"
                                objectValue={false}
                                labelKey="name"
                                value={this.props.values.pos}
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("pos")}
                            />
                        </div>
                        <div className="col-md-2">
                            <TextInput
                                name="capacity"
                                type="number"
                                value={this.props.values.capacity}
                                label="Kapacitás/Max létszám"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("capacity")}
                            />
                        </div>
                        <div className="col-md-2">
                            <TextInput
                                name="reservation_limit"
                                type="number"
                                value={this.props.values.reservation_limit}
                                label="Foglalási maximum"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("reservation_limit")}
                            />
                        </div>
                        <div className="col-md-2">
                            <TextInput
                                name="cancellation_offset"
                                type="number"
                                value={this.props.values.cancellation_offset || '0'}
                                label="Előleg visszatartás"
                                formatter={(value) => (value || '0') + ' nap'}
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("cancellation_offset")}
                            />
                        </div>
                        <div className="col-md-3">
                            <Select
                                component="ProductCategory"
                                storeType="local"
                                label="Típus"
                                name="category"
                                objectValue={false}
                                labelKey="name"
                                value={this.props.values.category}
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("category")}
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-3">
                            <div className="row">
                                <div className="col-md-6">
                                    <TextInput
                                        name="agefrom"
                                        type="number"
                                        value={this.props.values.agefrom}
                                        label="Életkortól"
                                        saveChanges={this.props.setFieldValue}
                                        {...this.props.getFieldProps("agefrom")}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <TextInput
                                        name="ageto"
                                        type="number"
                                        value={this.props.values.ageto}
                                        label="Életkorig"
                                        saveChanges={this.props.setFieldValue}
                                        {...this.props.getFieldProps("ageto")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <Select
                                storeType="local"
                                label="Fizetési mód"
                                name="payment_method_id"
                                optionname="ticket_payment_method"
                                objectValue={false}
                                isClearable={true}
                                value={this.props.values.payment_method_id}
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("payment_method_id")}
                            />
                        </div>
                        <div className="col-md-2">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="group_id"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Csoport azonosító"
                            />
                        </div>
                        <div className="col-md-2">
                            <label className="control-label">&nbsp;</label>
                            <CheckBox
                                name="public"
                                value={this.props.values.public}
                                label="Eseménye publikus"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("public")}
                            />
                        </div>

                        <div className="col-md-2">
                            <label className="control-label">&nbsp;</label>
                            <CheckBox
                                name="auto_checkup"
                                value={this.props.values.auto_checkup}
                                label="Automatikus jóváhagyás"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("auto_checkup")}
                            />
                        </div>
                        {!!this.props.values?.type?.preset?.dynamic &&
                            <div className="col-md-3">
                                <TextInput
                                    name="registration_expiry"
                                    type="number"
                                    value={this.props.values.registration_expiry}
                                    label="Foglaláshoz szükséges idő (perc)"
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("registration_expiry")}
                                />
                            </div>
                        }

                        {!this.props.values?.type?.preset?.single_event && this.props.values.locations?.length > 1 && <div className="col-md-3">
                            <label className="control-label">&nbsp;</label>
                            <CheckBox
                                name="multiple_locations"
                                value={!isTrue(this.props.values.multiple_locations)}
                                label="Külön-külön foglalható helszínek"
                                saveChanges={(field) => {
                                    this.props.setFieldValue(field, !isTrue(this.props.values.multiple_locations));
                                }}
                                {...this.props.getFieldProps("multiple_locations")}
                            />
                        </div>}
                        <div className="col-md-2">
                            <label className="control-label">&nbsp;</label>
                            <CheckBox
                                name="published"
                                value={this.props.values.published}
                                label="Megjelenik a honlapon"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("published")}
                            />
                        </div>
                    </div>
                    {!!this.props.values[this.props.componentConfig.idfield] && <>
                        <div className="row form-row">
                            <div className="col-md-4">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="programcategory"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Megjelenés helye a programok oldalon"
                                />
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="programcategories"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Megjelenés helye a programok oldalon"
                                />
                            </div>
                        </div>
                    </>
                    }
                    {!this.props.values?.type?.preset?.single_event && <div className="row form-row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="control-label">Helyszín(ek)</label>
                                <div className="input-group">
                                    <Select
                                        component="location"
                                        name="locations"
                                        isMulti={true}
                                        value={this.props.values.locations}
                                        label={false}
                                        labelKey="name"
                                        storeType="local"
                                        order={[{ field: "partner", direction: "DESC" }]}
                                        objectValue={true}
                                        filter={[
                                            {
                                                filters: [
                                                    {
                                                        field: "partner",
                                                        value: this.props.partner.partner_id
                                                    },
                                                    {
                                                        field: "partner",
                                                        operator: "isnull"
                                                    }
                                                ],
                                                operator: "OR"
                                            }
                                        ]}
                                        saveChanges={this.props.setFieldValue}
                                        {...this.props.getFieldProps("locations")}
                                    />
                                    <div className="input-group-btn">
                                        <NewLocationButton
                                            saveChanges={(location) => {
                                                this.props.setFieldValue('locations', [...(this.props.values.locations || []), location.id])
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <Tabs
                                    defaultTab={"loc_" + this.props.values.locations?.[0]?.id}
                                >
                                    {this.props.values.locations?.map((location, idx) => {
                                        if (!location.id) return;
                                        return <TabContent
                                            key={idx}
                                            tabName={"loc_" + location.id}
                                            tabLabel={location.name}
                                        >
                                            <TimeConfigEditor
                                                gridid={"ProgramLocationTimeConfigList"}
                                                presets={{ location: { id: location.id }, program: null }}
                                                inline={true}
                                                isLoading={this.props.isLoading}
                                                list={TimeConfigEditorList}
                                                editor={ModalEditor}
                                                selection={null}
                                                listFilter={[
                                                    {
                                                        field: "location",
                                                        value: location.id
                                                    },
                                                    {
                                                        field: "program",
                                                        operator: "isnull"
                                                    },
                                                ]}
                                                locationOptionFilter={[{
                                                    field: "roles.optionid",
                                                    value: "2"
                                                }]}
                                            />
                                        </TabContent>
                                    })}
                                </Tabs>
                            </div>
                        </div>
                    </div>}
                    {this.props.values[this.props.componentConfig.idfield] && <div className="row form-row">
                        <div className="col-sm-12">
                            <Figures name="figures" label="Képek" component={this.props.componentConfig.componentname}
                                componentId={this.props.values[this.props.componentConfig.idfield]} />
                        </div>
                    </div>}
                    <div className="row form-row">
                        <div className="col-md-12">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="list_description"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Lista leírás"
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="description"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Leírás"
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="url"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Url"
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <Select
                                    label="Foglalási oldal url-je"
                                    name="reservation_page"
                                    component="url"
                                    objectValue={true}
                                    isCreatAble={true}
                                    isClearable={true}
                                    labelKey="url"
                                    valueKey="id"
                                    storeType="remote"
                                    {...this.props.getFieldProps("reservation_page")}
                                    value={this.props.values.reservation_page}
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div>
                    </div>
                    {!this.props.values?.type?.preset?.dynamic ? (!this.props.values[this.props.componentConfig.idfield] ?
                        <DataGrid<EventListType>
                            pageSize={0}
                            program={this.props.values}
                            value={!events.length ? [{ idx: 0 }] : events}
                            type={EventList}
                            addItems={(items) => {
                                this.props.setFieldValue("events", [...events, ...items]);
                            }}
                            editItems={(items) => {
                                let list = [...events];
                                items.map((item) => {
                                    list[item.idx || 0] = { ...item };
                                });
                                this.props.setFieldValue("events", list);
                            }}
                            removeItems={(items) => {
                                items = items.map((data) => data.idx);
                                this.props.setFieldValue("events", events.filter(function (value, index) {
                                    return items.indexOf(index) === -1;
                                }));
                            }}
                        /> : <DataGrid<EventListType>
                            ref={(eventList) => this.eventList = eventList}
                            program={this.props.values}
                            pageSize={0}
                            component="Event"
                            view="admin"
                            filter={[{ field: "program", value: this.props.values[this.props.componentConfig.idfield] }]}
                            onLoadCompleted={(data) => {
                                this.setState({ events: [...data.items] });
                                data.items = [...data.items, ...events].reverse().reduce((all, item) => {
                                    if (!item) {
                                        return all;
                                    }
                                    if (all.find((c) => item.id && c.id + "" === "" + item.id)) {
                                        return all;
                                    }
                                    return [...all, item];
                                }, []).reverse().sort((a, b) => {
                                    const ids = data.items.map((item) => item.id);
                                    if (a.id && b.id) {
                                        return ids.indexOf(a.id) - ids.indexOf(b.id);
                                    }
                                    if (a.id && !b.id) {
                                        return -1;
                                    }
                                    if (b.id && !a.id) {
                                        return 1;
                                    }
                                    return 0;
                                });
                                return data;
                            }}
                            type={EventList}
                            addItems={(items) => {
                                this.props.setFieldValue("events", [...events, ...items].map((item, idx) => ({
                                    ...item,
                                    idx
                                })));
                                this.eventList.refresh();
                            }}
                            editItems={(items) => {
                                let newEvents = [...events];
                                items.map((item) => {
                                    if (item.idx !== undefined && item.idx !== null) {
                                        newEvents[item.idx] = { ...item };
                                        let old = { ...item };
                                        delete old.idx;
                                        let i = this.state.events.find((i) => i.id + "" === "" + old.id);
                                        if (newEvents[item.idx].id && i && isEqual(i, old)) {
                                            newEvents.splice(item.idx, 1);
                                        }
                                    } else {
                                        newEvents.push({ ...item, idx: newEvents.length });
                                    }
                                });
                                this.props.setFieldValue("events", newEvents);
                                this.eventList.refresh();
                            }}
                            removeItems={(items) => {
                                let removeEvents = [];
                                let existsEvents = [];
                                items.map((item) => {
                                    if (item.idx !== undefined && item.idx !== null) {
                                        removeEvents.push(item.idx);
                                    }
                                    if (item.id) {
                                        existsEvents.push(item);
                                    }
                                });
                                this.props.setFieldValue("events", events.filter(function (value, index) {
                                    return removeEvents.indexOf(index) === -1;
                                }));
                                return existsEvents;
                            }}
                        />) : null}
                    {
                        !!this.props.values[this.props.componentConfig.idfield] && <Fragment>
                            <label className="control-label">Foglalható időpontok</label>
                            <div className="form-group">
                                <TimeConfigEditor
                                    listFilter={{
                                        field: "program",
                                        value: this.props.values[this.props.componentConfig.idfield]
                                    }}
                                    presets={{ program: this.props.values }}
                                    editorContext="ProgramTimeConfig"
                                    list={FragmentEditor}
                                    inline={true}
                                    editor={ModalEditor}
                                />
                            </div>
                        </Fragment>
                    }
                    {
                        !!this.props.values[this.props.componentConfig.idfield] && this.props.values.payment_method_id !== "2" &&
                        <Fragment>
                            <label className="control-label">Jegytípusok</label>
                            <div className="form-group">
                                <TicketTypeEditor
                                    listFilter={{
                                        field: "program",
                                        value: this.props.values[this.props.componentConfig.idfield]
                                    }}
                                    presets={{ program: this.props.values }}
                                    editorContext="ProgramTicketType"
                                    list={FragmentEditor}
                                    inline={true}
                                    editor={ModalEditor}
                                />
                            </div>
                        </Fragment>
                    }
                    {
                        !!this.props.values[this.props.componentConfig.idfield] &&
                        <Fragment>
                            <div className="row form-row">
                                <div className="col-md-12">
                                    <label className="control-label">Kvízek</label>
                                    <QuizEditor
                                        editorContext="ProgramQuizEditor"
                                        gridid={"ProgramQuizEditor"}
                                        presets={{
                                            component_id: this.props.values[this.props.componentConfig.idfield],
                                            component: "Program",
                                            field: "quizzes"
                                        }}
                                        isLoading={this.props.isLoading}
                                        editor={ModalEditor}
                                        list={FragmentEditor}
                                        selection={null}
                                    />
                                </div>
                            </div>
                            <div className="row form-row">
                                <div className="col-md-12">
                                    <label className="control-label">Választható fizetős lehetőségek</label>
                                    <ProgramOptionEditor
                                        editorContext="ProgramProgramOptionEditor"
                                        gridid={"ProgramProgramOptionList"}
                                        presets={{ program: this.props.values }}
                                        isLoading={this.props.isLoading}
                                        editor={ModalEditor}
                                        list={FragmentEditor}
                                        selection={null}
                                        listFilter={[
                                            {
                                                field: "program",
                                                value: this.props.values[this.props.componentConfig.idfield]
                                            }
                                        ]}
                                    />
                                </div>
                            </div>
                        </Fragment>
                    }
                    {!!this.props.values[this.props.componentConfig.idfield] && <SeoField {...this.props} />}
                    <div className="row form-row">
                        <div className="col-md-12">
                            <label className="control-label">Dokumentumok (e-mail-csatolmány)</label>
                            {this.props.values[this.props.componentConfig.idfield] ? <Dropzone disableClick disabled={false} className="image-pool" ref={(node) => { this.dropzoneRef = node; }} onDrop={this.onDrop}>
                                <SelectorGrid
                                    {...this.props.getFieldProps("documents")}
                                    ref={(e) => this.documents = e}
                                    disabled={false}
                                    component="Program"
                                    name="documents"
                                    parentid={this.props.values.id}
                                    data={this.props.values}
                                    className={"p-small-table"}
                                    view={["filename", "path"]}
                                    addButton={false}
                                    columns={{
                                        "filename": {
                                            header: 'Fájl név',
                                            width: 6,
                                            sortable: true,
                                            filterable: true
                                        },
                                        "type": {
                                            header: 'Típus',
                                            width: 4,
                                            sortable: true,
                                            filterable: true,
                                            renderer: remoteOptionFormatter("DocumentType")
                                        }
                                    }}
                                    pageSize={0}
                                    componentConfig={this.props.componentConfig}
                                    orderBy={{ field: "filename", direction: "ASC" }}
                                    paginatorRight={(props) =>
                                        <Fragment>

                                            <SplitButton
                                                onClick={this.openDialog}
                                                label={"Dokumentum"}
                                                icon="fa fa-upload"
                                                className="p-button-secondary"
                                                {...props}
                                            />
                                        </Fragment>}
                                />
                            </Dropzone> : <Fragment>Kérlek mentsd el a terméket feltöltés előtt!</Fragment>}
                        </div>
                    </div>
                </form>
            </Fragment>
        );
    }
}

export default connect((state) => {
    return {
        partner: state.app.context.partner
    }
})(createForm(ProgramForm));
